function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14 .667A13.321 13.321 0 00.667 14c0 7.373 5.96 13.333 13.333 13.333S27.333 21.373 27.333 14 21.373.667 14 .667zm6.666 18.12l-1.88 1.88L14 15.88l-4.787 4.787-1.88-1.88L12.12 14 7.333 9.213l1.88-1.88L14 12.12l4.787-4.787 1.88 1.88L15.88 14l4.786 4.787z"
});

var SvgCircleX = function SvgCircleX(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 32 32",
    fill: "#FE707D"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 32 32' fill='%23FE707D' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M13.9998 0.666626C6.6265 0.666626 0.666504 6.62663 0.666504 14C0.666504 21.3733 6.6265 27.3333 13.9998 27.3333C21.3732 27.3333 27.3332 21.3733 27.3332 14C27.3332 6.62663 21.3732 0.666626 13.9998 0.666626ZM20.6665 18.7866L18.7865 20.6666L13.9998 15.88L9.21317 20.6666L7.33317 18.7866L12.1198 14L7.33317 9.21329L9.21317 7.33329L13.9998 12.12L18.7865 7.33329L20.6665 9.21329L15.8798 14L20.6665 18.7866Z' /%3E %3C/svg%3E";
export { SvgCircleX as ReactComponent };